var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOcrAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "15 15 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Combined-RunAI-Detection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Combined-Rectangle",
    className: "svg-stroke svg-stroke-color",
    stroke: "white",
    strokeWidth: 1.3,
    x: 15.65,
    y: 15.65,
    width: 18.7,
    height: 18.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 15.65,
    x2: 25,
    y2: 34.35,
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("text", {
    id: "AI",
    className: "svg-path2",
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontSize: 7.5,
    fontWeight: 500,
    letterSpacing: 0.2,
    fill: "white"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17.2,
    y: 28
  }, "AI")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.5, 21.5) scale(0.35)",
    className: "svg-fill-color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m2 14H7v-2h7zm3-4H7v-2h10zm0-4H7V7h10z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrAnalysis);
export default __webpack_public_path__ + "static/media/ocr-analysis.e76c79522b0b14dc2428545e34f20dc1.svg";
export { ForwardRef as ReactComponent };